import { FeApi } from '@/api/fe-api';
import {
  type WarrantyPenalty,
  type WarrantyPenaltyCurrent,
  type WarrantyPenaltyPrediction,
} from '@/warranty-v3/entities/warranty-penalty';

function fixBackendPercentage(value: number): number {
  return value / 100;
}

export function warrantyPenaltyCurrentMapper(
  data: FeApi.WarrantyPenaltyCurrent,
): WarrantyPenaltyCurrent {
  return {
    lastDetectedAt: data.last_detected_at
      ? new Date(data.last_detected_at)
      : undefined,
    penalty: fixBackendPercentage(data.penalty),
    extremeValue: data.extreme_value,
    extremeValueUnit: data.extreme_value_unit,
    durationHours: data.duration_hours ?? undefined,
    count: data.count ?? undefined,
  };
}

export function warrantyPenaltyPredictionMapper(
  data: FeApi.WarrantyPenaltyPrediction,
): WarrantyPenaltyPrediction {
  return {
    appliesAt: new Date(data.applies_at),
    penaltyDelta: fixBackendPercentage(data.penalty_delta),
  };
}

export function warrantyPenaltyMapper(
  data: FeApi.WarrantyPenalty,
): WarrantyPenalty {
  return {
    id: data.id,
    description: data.description,
    current: data.current
      ? warrantyPenaltyCurrentMapper(data.current)
      : undefined,
    prediction: data.prediction
      ? warrantyPenaltyPredictionMapper(data.prediction)
      : undefined,
  };
}

export function warrantyPenaltiesMapper(
  data: FeApi.WarrantyPenalty[],
): WarrantyPenalty[] {
  return data.map(warrantyPenaltyMapper);
}
